<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>INFRASTRUCTURE</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Infrastructure</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>


<!-- ABOUTUS
       ================================================== -->
<section>
    <div class="container">
        <div class="row align-items-center mt-0">

            <div class="col-lg-6 col-xl-6 mt-0 ">
                <div class="section-heading text-start mb-0">
                    <span class="sub-title">Available Land</span>
                </div>

                <table class="table table-responsive table-stripped table-bordered">
                    <thead>
                    <tr>
                        <td class="bg-secondary text-white" width="500px">Detail</td>
                        <td class="bg-secondary text-white" width="500px">Area</td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>Total land</td>
                        <td>111 Acre</td>
                    </tr>
                    <tr>
                        <td>Functional Area</td>
                        <td>27.7 Acre</td>
                    </tr>
                    <tr>
                        <td>Buildings’ Area</td>
                        <td>7.1 Acre</td>
                    </tr>
                    <tr>
                        <td>Green Area</td>
                        <td>9.6 Acre</td>
                    </tr>
                    </tbody>
                </table>

            </div>

            <div class="col-lg-6 col-xl-6  ">
                <div class="section-heading text-start mb-0">
                    <span class="sub-title">Central Library</span>
                </div>

                <table class="table table-responsive table-stripped table-bordered">
                    <thead style="background-color: #e67e22; color: white;">
                    <tr>
                        <th width="500px" class="bg-secondary text-white">Detail</th>
                        <th width="500px" class="bg-secondary text-white">Area</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>

                        <td>Area of the Library</td>
                        <td class="zoom">4000 Sq. meter</td>
                    </tr>
                    <tr>
                        <td>Reading Space</td>
                        <td class="zoom">1000 Sq. meter</td>
                    </tr>
                    <tr>
                        <td>Sitting Capacity in the Library</td>
                        <td class="zoom">250</td>
                    </tr>
                    <tr>
                        <td>Library Hours</td>
                        <td class="zoom">9:30am to 8:30pm</td>

                    </tr>
                    <tr>
                        <td>Number of Books Title</td>
                        <td class="zoom">3697</td>

                    </tr>
                    <tr>
                        <td>Number of Books/Title</td>
                        <td class="zoom">17032 / 3875</td>

                    </tr>
                    <tr>
                        <td>Number of Journal (Printed)</td>
                        <td class="zoom">24</td>

                    </tr>
                    <tr>
                        <td>Number of Computers in Library</td>
                        <td class="zoom">36</td>

                    </tr>
                    <tr>
                        <td colspan="2" class="zoom">Xerox &amp; Printing facilities are available</td>

                    </tr>

                    </tbody>
                </table>

            </div>


            <div class="col-lg-6 col-xl-6  ">
                <div class="section-heading text-start mb-0">
                    <span class="sub-title">ICT Infrastructure</span>
                </div>

                <table class="table table-responsive table-stripped table-bordered">
                    <thead style="background-color: #e67e22; color: white;">
                    <tr>
                        <th width="500px" class="bg-secondary text-white">Detail</th>
                        <th width="500px" class="bg-secondary text-white">Area</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>Number of computers in the University</td>
                        <td class="zoom">515</td>
                    </tr>
                    <tr>
                        <td>Power Back up for computers</td>
                        <td class="zoom">Fourteen 6KVA UPS</td>
                    </tr>
                    <tr>
                        <td>Number of printers</td>
                        <td class="zoom">113</td>
                    </tr>
                    <tr>
                        <td>Heavy Duty Printers</td>
                        <td class="zoom">10</td>
                    </tr>
                    <tr>
                        <td>Color Printers</td>
                        <td class="zoom">5</td>
                    </tr>
                    <tr>
                        <td>Laser Printers</td>
                        <td class="zoom">100</td>
                    </tr>
                    <tr>
                        <td>Number of Smart Boards</td>
                        <td class="zoom">15</td>
                    </tr>
                    <tr>
                        <td>Number of LCD Projectors</td>
                        <td class="zoom">16</td>
                    </tr>
                    <tr>
                        <td>ICARD Printer</td>
                        <td class="zoom">2</td>
                    </tr>


                    </tbody>
                </table>

            </div>


            <div class="col-lg-6 col-xl-6  ">
                <div class="section-heading text-start mb-0">
                    <span class="sub-title">Sports Infrastructure</span>
                </div>

                <table class="table table-responsive table-stripped table-bordered">
                    <thead style="background-color: #e67e22; color: white;">
                    <tr>
                        <th width="1000px" class="bg-secondary text-white">University has well maintained grounds for
                            following Sports:
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td class="zoom">Cricket Ground</td>
                    </tr>
                    <tr>
                        <td class="zoom">Football Ground</td>
                    </tr>
                    <tr>
                        <td class="zoom">Lawn Tennis Court</td>
                    </tr>
                    <tr>
                        <td class="zoom">Basketball Ground</td>
                    </tr>
                    <tr>
                        <td class="zoom">Volleyball Ground</td>
                    </tr>
                    <tr>
                        <td class="zoom">Badminton Court</td>
                    </tr>
                    <tr>
                        <td class="zoom">Adequate infrastructure available for Athletics</td>
                    </tr>
                    <tr>
                        <td class="zoom">Separate Gymnasium infrastructure for boys and girls.</td>
                    </tr>

                    </tbody>
                </table>

            </div>

            <div class="col-lg-12 col-xl-12 ">
                <div class="section-heading text-start mb-0">
                    <span class="sub-title">Hostels, Faculty Accomodation, Guest House & Mess</span>
                </div>

                <table class="table table-responsive table-stripped table-bordered">
                    <thead style="background-color: #e67e22; color: white;">
                    <tr>
                        <th width="500px" class="text-white bg-secondary">Name of Hostel</th>
                        <th width="500px" class="text-white bg-secondary">No. of Rooms</th>
                        <th width="500px" class="text-white bg-secondary">Total Capacity</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>Boys Hostel (H1)</td>
                        <td>57</td>
                        <td>171</td>
                    </tr>
                    <tr>
                        <td>Boys Hostel (H2)</td>
                        <td>59</td>
                        <td>177</td>
                    </tr>
                    <tr>
                        <td>Boys Hostel (H3)</td>
                        <td>65</td>
                        <td>195</td>
                    </tr>
                    <tr>
                        <td>Girls Hostel (GH1)</td>
                        <td>57</td>
                        <td>171</td>
                    </tr>
                    <tr>
                        <td>Total Capacity 714</td>
                        <td>Boys 543</td>
                        <td>Girls 171</td>
                    </tr>

                    </tbody>
                </table>
                <p>University has well furnished faculty residence and guest house.
                    Separate mess facility for boys and girls with total sitting capacity of 300.</p>
            </div>

            <div class="col-lg-6 col-xl-6 ">
                <div class="section-heading text-start mb-0">
                    <span class="sub-title">Transport</span>
                </div>

                <p>University provides transport facilities to surrounding area students and faculty.</p>
                <div class="category-box bg-secondary text-center border-1 p-3 m-1">
                    <a href="#!" class="text-white text-center"><i class="fa fa-star"></i> No. of Buses : 16</a>
                </div>

                <p>University also provides transport facilities (light vehicles) for hostlers and faculty</p>
                <div class="category-box bg-secondary text-center border-1 p-3 m-1">
                    <a href="#!" class="text-white text-center"><i class="fa fa-star"></i> For general purposes : 05</a>
                </div>

                <div class="category-box bg-secondary text-center border-1 p-3 m-1">
                    <a href="#!" class="text-white text-center"><i class="fa fa-star"></i> For officers : 04</a>
                </div>

                <div class="category-box bg-secondary text-center border-1 p-3 m-1">
                    <a href="#!" class="text-white text-center"><i class="fa fa-star"></i> Ambulance : 01</a>
                </div>

                <div class="category-box bg-secondary text-center border-1 p-3 m-1">
                    <a href="#!" class="text-white text-center"><i class="fa fa-star"></i> No. of pickup : 01</a>
                </div>
            </div>

            <div class="col-lg-6 col-xl-6 ">
                <div class="section-heading text-start mb-0">
                    <span class="sub-title">ELECTRICITY BACK-UPS</span>
                </div>
                <div class="category-box bg-secondary text-center border-1 p-3 m-1">
                    <a href="#!" class="text-white text-center"><i class="fa fa-star"></i> High Voltage Supply line : 11
                        KV</a>
                </div>

                <div class="category-box bg-secondary text-center border-1 p-3 m-1">
                    <a href="#!" class="text-white text-center"><i class="fa fa-star"></i> Number of Gen sets for Power
                        Backup : 03</a>
                </div>
                <p>(250 KVA, 125 KVA, 62 KVA)</p>
            </div>

        </div>
        <div class="shape20">
            <img src="assets/img/bg/bg-02.jpg" alt="...">
        </div>
        <div class="shape18">
            <img src="assets/img/bg/bg-01.jpg" alt="...">
        </div>
        <div class="shape21">
            <img src="assets/img/bg/bg-03.jpg" alt="...">
        </div>
    </div>
</section>


<!-- EXTRA
      ================================================== -->
<section class="py-0">
    <div class="container">
        <div class="row g-0">
            <div class="col-lg-6 order-2 order-lg-1">
                <div class="instructor-partner-content h-100 bg-secondary">
                    <h2 class="text-white h1 mb-3">SEWAGE SYSTEM</h2>
                    <p class="text-white"><i class="fa fa-star"></i> University has Sewage Treatment Plant of Capacity
                        200 KLD.</p>
                    <p class="text-white"><i class="fa fa-star"></i> Area of the Sewage Treatment Plant: 335 Sq. Mts.
                    </p>
                </div>
            </div>
            <div class="col-lg-6 bg-img cover-background min-height order-1 order-lg-2"
                 data-background="img/content/about-04.jpg"
                 style="background-image: url(assets/img/content/sewage.jpg);">
            </div>
        </div>
        <div class="row g-0">
            <div class="col-lg-6 bg-img cover-background min-height" data-background="img/content/about-05.jpg"
                 style="background-image: url(assets/img/content/watersupply.jpg);">
            </div>
            <div class="col-lg-6">
                <div class="instructor-content h-100 bg-primary">
                    <h2 class="h1 mb-3 text-white">WATER SUPPLY SYSTEM</h2>
                    <p class="text-white"><i class="fa fa-star"></i> 24 Hrs. Continuous water Supply.</p>
                    <p class="text-white"><i class="fa fa-star"></i> Number of bores for Water Supply: 04</p>
                    <p class="text-white"><i class="fa fa-star"></i> One Main Water Tank of Capacity : 1,25,000 Litre
                    </p>
                    <p class="text-white"><i class="fa fa-star"></i> RO water Supply for drinking.</p>
                </div>
            </div>
        </div>
        <div class="row g-0">
            <div class="col-lg-6 order-2 order-lg-1">
                <div class="instructor-partner-content h-100 bg-secondary">
                    <h2 class="text-white h1 mb-3">MEDICAL INFRASTRUCTURE</h2>
                    <p class="text-white"><i class="fa fa-star"></i> University has well established Medical Facility
                        for Students and Staff</p>
                    <p class="text-white"><i class="fa fa-star"></i> Doctor’s Room</p>
                    <p class="text-white"><i class="fa fa-star"></i> Two Wards with Required Medical
                        Accessories/Instruments (Stretcher, Wheelchairs
                        etc.)</p>
                    <p class="text-white"><i class="fa fa-star"></i> 05 Beds in Each Ward</p>
                    <p class="text-white"><i class="fa fa-star"></i> One Waiting Hall</p>
                    <p class="text-white"><i class="fa fa-star"></i> 24 hours Emergency Facility</p>
                    <p class="text-white"><i class="fa fa-star"></i> Ambulance Service</p>
                    <p class="text-white"><i class="fa fa-star"></i> Emergency Medicines</p>
                    <p class="text-white"><i class="fa fa-star"></i> Tie up with Hospitals</p>

                </div>
            </div>
            <div class="col-lg-6 bg-img cover-background min-height order-1 order-lg-2"
                 data-background="img/content/about-04.jpg"
                 style="background-image: url(assets/img/content/sewage.jpg);">
            </div>
        </div>
    </div>
</section>
